<template>
  <div class="content">
    <!-- Content Main -->
    <div class="content-main">
      <div
        v-if="item.brand && item.brand !== 'unknown'"
        class="product-brand"
      >
        {{ item.brand }}
      </div>
      <div class="title">
        <h3 class="product-title">
          <router-link
            :to="path"
            class="product-title-link"
          >
            {{ title }}
          </router-link>
        </h3>
        <div
          v-if="item.region && item.region !== 'unknown'"
          class="product-region"
        >
          {{ item.region }}
        </div>
      </div>

      <!-- <div class="product-subtitle">{{ content.subtitle }} {{ vintageDisplay.value }}</div> -->
      <div
        v-if="hasVarietal"
        class="product-subtitle"
      >
        {{ varietal }}
      </div>
      <div
        class="product-description"
        v-html="item.abstract"
      />
    </div>
    <!-- / Content Main -->

    <div class="content-actions">
      <div class="pricing-region simple-display" v-if="showPrice">
        <div
          v-if="packPricingEnabled"
          class="pack-item-element"
        >
          <div class="pack-item">
            <div class="price-value">
              <PriceElement
                :price="packPrice"
                prepend="$"
              />
              <div class="label-divider">
                /
              </div>
              <div class="price-label">
                {{ packPriceLabel }}
              </div>
            </div>
          </div>
        </div>

        <div class="price-item">
          <div
            class="price-value"
            title="Per Bottle"
          >
            <PriceElement
              v-if="displayRRP"
              :price="rrpPrice"
              class="rrp"
            />
            <PriceElement
              :price="sellPrice"
              class="sale-price"
            />
          </div>
        </div>
      </div>

      <div class="card-actions">
        <HighlightButton
          :disabled="outOfStock"
          :class="stockManagedClass"
          :title="stockManagedText"
          button-type="pill"
          button-style="solid"
          button-size="small"
          button
          @clicked="addToCartLinkClicked"
        />
      </div>
    </div>
  </div>
</template>

<script>
import carouselProductMixin from '../../mixins/carouselProductMixin'
import purchaseMixin from '@aspedia/vuejs-ecommerce-ui/mixins/item-purchase-qty.js'
import generalutils from '@aspedia/vuejs-ecommerce-ui/mixins/general-utils.js'
import PriceElement from '../PriceElement.vue'

export default {
  name: 'carousel-product-list-content',
  components: {
    PriceElement
  },
  mixins: [carouselProductMixin, purchaseMixin, generalutils]
}
</script>

<style lang="scss" scoped>
@import "../../styles/product-list-card-styles.scss";
</style>
